import React from 'react';
import { Linkedin, Mail, Heart } from 'lucide-react';
import { personalInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-blue-900 text-white py-12">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-center md:text-left">
            <h3 className="text-2xl font-bold mb-2">{personalInfo.name}</h3>
            <p className="text-blue-200">{personalInfo.title}</p>
          </div>

          <div className="flex items-center gap-6">
            <a
              href={`mailto:${personalInfo.email}`}
              className="hover:text-blue-300 transition-colors transform hover:scale-110"
              aria-label="Email"
            >
              <Mail size={24} />
            </a>
            <a
              href={`https://${personalInfo.linkedin}`}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-300 transition-colors transform hover:scale-110"
              aria-label="LinkedIn"
            >
              <Linkedin size={24} />
            </a>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-blue-800 text-center">
          <p className="text-blue-200 flex items-center justify-center gap-2">
            © {currentYear} {personalInfo.name}. Built with
            <Heart size={16} className="text-red-400" fill="currentColor" />
            for international opportunities.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;